import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { FirebaseApp } from '@angular/fire/app';
import { getAuth, signOut } from 'firebase/auth';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AuthService } from 'src/app/services/authservice/auth-service';
import Swal from 'sweetalert2';
import { Store } from '@ngrx/store';
import { AppState, selectAuthState } from 'src/app/store/app.states';
import { LogOut } from 'src/app/store/actions/auth.actions';
import { StorageService } from 'src/app/services/common/storage';

@Component({
  selector: 'app-auth',
  templateUrl: './auth.component.html',
  styleUrls: ['./auth.component.scss']
})
export class AuthentificationComponent implements OnInit {
  public resetPasswordForm: FormGroup;
  public error:string;
  public message:string;
  ngUnsubscribe: Subject<any> = new Subject<any>();
  mode: any;
  actionCode: any;
  actionCodeChecked: boolean;
  showSpinner: boolean;
  isAuthenticated: any;

  constructor(public localStorage:StorageService,private store: Store<AppState>,public auth:AuthService, private afApp: FirebaseApp,public router:Router, private activatedRoute: ActivatedRoute) {
    this.resetPasswordForm = new FormGroup({
      confirmpassword: new FormControl(
        '',
        [
          Validators.required,
        ]),
      password: new FormControl(
        '',
        [
          Validators.required,
        ])
    });
   }

   
  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

   ngOnInit() {

    this.store.select(selectAuthState).subscribe(state => {
      this.isAuthenticated = state.isAuthenticated;
    })
    
    const auth = getAuth(this.afApp);
    this.activatedRoute.queryParams
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(params => {

        if (!params) {this.router.navigate(['/'])};
  
        this.mode = params['mode'];
        this.actionCode = params['oobCode'];
  
        switch (this.mode) {
          case 'resetPassword': {
            this.auth.verifyPasswordResetCode(auth,this.actionCode).then(email => {
              this.actionCodeChecked = true;
            }).catch(e => {
              this.error ="Code d'action invalide ou expiré. Réinitialiser à nouveau votre mot de passe";
              this.message ="";
            });
          } break
          case "recoverEmail": {
  
          } break
          case 'verifyEmail': {
  
          } break
          default: {
            console.log('query parameters are missing');
            this.router.navigate(['login']);
          }
        }
      })
  }

    /**
    * Go to pre-registration users page
    */
  logOut(): void {
      const auth = getAuth(this.afApp);
      signOut(auth).then(x=>{
        this.store.dispatch(new LogOut(this.localStorage));

      });

  }
  
  public onSubmit(){
     this.showSpinner = true;
     if(!this.actionCodeChecked)
     {
      this.error ="Code d'action invalide ou expiré. Réinitialiser à nouveau votre mot de passe";
      this.message ="";
      this.showSpinner = false;
      return;
     }

     if(this.resetPasswordForm.value.confirmpassword != this.resetPasswordForm.value.password){
       this.error ="Les mots de passe ne sont pas identiques";
       this.message ="";
       this.showSpinner = false;
     }
     else{
      this.auth.confirmPassword(getAuth(this.afApp),this.actionCode,this.resetPasswordForm.value.password).then(x=>
        {
          this.validated();
        },errorCode=>{
          switch (errorCode.code) {
            case 'auth/weak-password':
              this.error = 'Le mot de passe doit comporter au moins 6 caractères';
              break;
             default:
              this.error ="Code d'action invalide ou expiré. Réinitialiser à nouveau votre mot de passe";
              break;
          }

          this.message ="";
          this.showSpinner = false;
        })
      
     }

  }

  private validated(){
    Swal.fire({
      position: 'center',
      icon: 'success',
      title: 'Ton nouveau mot de passe a été pris en compte',
      showConfirmButton: false,
      timer: 1900
    }).then((result) => {

      if(this.isAuthenticated){
        this.router.navigateByUrl("/");
      }
      else{
        this.router.navigateByUrl("login");
      }
    })
      
  }

}
